var MediaQueryServiceModule = /** @class */ (function () {
    function MediaQueryServiceModule() {
    }
    return MediaQueryServiceModule;
}());
export { MediaQueryServiceModule };
